module.exports = __webpack_public_path__ + "img/create-new.1331c972.png";